import BaseModel from './BaseModel';

class IntegrationEvent extends BaseModel {}

IntegrationEvent.getListingFields = () => [
    'id',
    'occurred_at',
    'kind',
    'channel',
    'name',
    'status',
    'resource_ref',
    'account_id',
    'transaction_id',
    'payment_request_id',
    'user_id',
    'user_display_name',
];

export default IntegrationEvent;
